module.exports = __webpack_public_path__ + "static/media/53.fd65b871.jpg";